export const APIKnowledge = "https://directus.poparce.ru";
export const KNOWLEDGE_TREE_FIELDS = [
  "id",
  "name",
  "slug",
  "order",
  "parent",
  "status",

  "children.id",
  "children.name",
  "children.slug",
  "children.order",
  "children.parent",
  "children.status",

  "children.docs.id",
  "children.docs.title",
  "children.docs.slug",
  "children.docs.order",
  "children.docs.status",

  "docs.id",
  "docs.title",
  "docs.slug",
  "docs.order",
  "docs.status",
] as const;

export type KnowledgeTreeField = (typeof KNOWLEDGE_TREE_FIELDS)[number];
